import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// the translations
import resources from 'locales';

i18n.use(initReactI18next).init({
  resources,
  lng: 'es',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
